export default "__VITE_ASSET__Dnkpf3CI__"